(function(){
  // Price cards drive the offer box (keeping the chosen length), then scroll to buy — fixes the 5ft-downgrade trap.
  [].slice.call(document.querySelectorAll('.ov-card a[data-pack]')).forEach(function(a){
    a.addEventListener('click',function(e){
      var q=a.getAttribute('data-pack');
      var chip=document.querySelector('#packs label[data-qty="'+q+'"]');
      if(chip){e.preventDefault();chip.click();var b=document.getElementById('buy');if(b)b.scrollIntoView({behavior:'smooth',block:'start'});}
    });
  });
  // Scroll-reveal for long-page sections (guarded; hero .rv keeps its load animation).
  try{
    var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!rm&&'IntersectionObserver' in window){
      var els=[].slice.call(document.querySelectorAll('.ov-journey,.ov-pricecards,.ov-reversal,.ov-capture,.ov-card,.cro-authority,.feat .card,.cro-seq .step,.ov-rev,.ov-jstep'));
      els.forEach(function(el){el.classList.add('ov-reveal');});
      var io=new IntersectionObserver(function(ents){ents.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
      els.forEach(function(el){io.observe(el);});
    }
  }catch(e){}
})();
